import { Menu, FileText, Bell, Home, RefreshCw } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useMobileMenu } from "@/context/MobileMenuContext";
import { useReloadRoute } from "@/utils/router";

export default function BottomNav() {
  const location = useLocation();
  const reloadRoute = useReloadRoute();
  const { setIsOpen: setIsMobileMenuOpen } = useMobileMenu();

  const isTransactionsActive = location.pathname === "/history";
  const isNotificationsActive = location.pathname === "/receipts";
  const isBuySellActive = location.pathname === "/";

  return (
    <nav className="fixed bottom-0 left-2 right-2 bg-primary/80 backdrop-blur-md rounded-t-3xl md:hidden z-50 shadow-lg border-t border-white/10">
      <ul className="grid grid-cols-4 gap-0 py-2 px-1">
        <li className="text-center">
          <button onClick={() => setIsMobileMenuOpen(true)} className="flex flex-col items-center gap-1 w-full py-1 text-white active:opacity-70 transition-opacity">
            <Menu size={20} strokeWidth={1.5} className="stroke-white" />
            <span className="text-xs text-white font-medium">منو</span>
          </button>
        </li>

        <li className="text-center">
          <Link to="/history" className="flex flex-col items-center gap-1 w-full py-1 text-white relative active:opacity-70 transition-opacity">
            <FileText size={20} strokeWidth={1.5} className="stroke-white" />
            <span className="text-xs text-white font-medium">صورت حساب</span>
            {isTransactionsActive && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-white rounded-full" />}
          </Link>
        </li>

        <li className="text-center">
          <button onClick={reloadRoute} className="flex flex-col items-center gap-1 w-full py-1 text-white active:opacity-70 transition-opacity" title="بارگذاری مجدد">
            <RefreshCw size={20} strokeWidth={1.5} className="stroke-white" />
            <span className="text-xs text-white font-medium">بروزرسانی</span>
          </button>
        </li>

        {/* <li className="text-center">
          <Link to="/receipts" className="flex flex-col items-center gap-1 w-full py-1 text-white relative active:opacity-70 transition-opacity">
            <Bell size={20} strokeWidth={1.5} className="stroke-white" />
            <span className="text-xs text-white font-medium">اعلانات</span>
            {isNotificationsActive && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-white rounded-full" />}
          </Link>
        </li> */}

        <li className="text-center">
          <Link to="/" className="flex flex-col items-center gap-1 w-full py-1 text-white relative active:opacity-70 transition-opacity">
            <Home size={20} strokeWidth={1.5} className="stroke-white" />
            <span className="text-xs text-white font-medium">خرید/فروش</span>
            {isBuySellActive && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-10 h-0.5 bg-white rounded-full" />}
          </Link>
        </li>
      </ul>
    </nav>
  );
}
